module.exports = __webpack_public_path__ + "static/img/act02.c6dbc51.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/act02.jpeg
// module id = uikE
// module chunks = 76